<template>
  <!-- 物流监控 -->
 <div >
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="120px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="searchBox inpBox">
            <div class="gjhBox">
              <el-form-item label="捆包号:" prop="cargoBarcodes">
                <el-input  placeholder=""   type="textarea" v-model="searchFrom.cargoBarcodes" class="gjh"></el-input>
              </el-form-item>
            </div>
            <div class="item">
               <el-form-item label="货物类型:" prop="goodType">
                <el-input  placeholder="" v-model="searchFrom.goodType"></el-input>
              </el-form-item>
              <el-form-item label="最新物流状态 :" prop="currentStatus">
              <el-select v-model="searchFrom.currentStatus" placeholder="请选择">
                <el-option  label="请选择" :value=null ></el-option>
                <el-option  label="已包装" value="0" ></el-option>
                <el-option  label="已入库" value="1" ></el-option>
                <el-option  label="已出库" value="2" ></el-option>
                <el-option  label="汽运中" value="3" ></el-option>
                <el-option  label="汽运完成" value="4" ></el-option>
                <el-option  label="已装船" value="5" ></el-option>
                <el-option  label="海运中" value="6" ></el-option>
                <el-option  label="已卸船" value="7" ></el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="品名:" prop="productName">
                <el-input  placeholder="" v-model="searchFrom.productName"></el-input>
              </el-form-item>
              <el-form-item label="材质:" prop="model">
                <el-input  placeholder="" v-model="searchFrom.model"></el-input>
              </el-form-item>
              <el-form-item label="规格:" prop="specification">
              <el-input  placeholder="" v-model="searchFrom.specification"></el-input>
              </el-form-item>
            </div>
        </div>

       <div class="searchBtnBox">
         <el-form-item btnCode="004P00FB001"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>

       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="监控" width="120">
            <template slot-scope="scope">
              <el-button type="text" size="mini"  btnCode="004P00FB001"  v-if="btnFlg[1]"  @click="QLCfn(scope.row)">查看</el-button>
            </template>
        </el-table-column>
        <el-table-column property="currentStatus" label="最新物流状态"  min-width="150">
          <template scope="scope">{{[ "已包装", "已入库", "已出库", "汽运中", "汽运完成", "已装船", "海运中", "已卸船"][scope.row.currentStatus]}}</template>
        </el-table-column>
        <el-table-column property="cargoBarcode"  width="200"  :formatter="emptyFn"   label="捆包号"></el-table-column>
        <el-table-column property="goodType"  width="200"  :formatter="emptyFn"   label="货物类型"></el-table-column>
         <el-table-column property="productName" width="200" :formatter="emptyFn"  label="品名"></el-table-column>
        <el-table-column property="model" width="200" :formatter="emptyFn" label="材质"></el-table-column>
        <el-table-column property="specification" width="200" :formatter="emptyFn"  label="规格"></el-table-column>
        <el-table-column property="grossWeight"  width="200" :formatter="emptyFn" label="重量(吨)"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 货物监控 -->
    <quanLiuCheng  :row-data="row" v-if="zujianFlag" @destroy="destroy"></quanLiuCheng>
 </div>

</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import quanLiuCheng from '@/views/soc-stock/logisticsM/quanLiuCheng.vue'
import { dropDownList } from '@/api/soc-stock'
import { goodList } from '@/api/data-center-server'
export default {
  components: {
    quanLiuCheng
  },
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 查询调价
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: 'false',
      total: 0,
      productTypes: [],
      zujianFlag: false,
      row: null,
      btnFlg: [],
      btnIdArr: ['004P00FB001', '004P00FB002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/SlogisticsM')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  methods: {
    // 全流程
    QLCfn (row) {
      this.row = row
      this.zujianFlag = true
    },
    destroy () {
      this.zujianFlag = false
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      goodList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },

    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
    }
  }
}
</script>

<style scoped lang='less'>
.searchBox{
  display: flex;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.gjhBox{
  display: flex;
}
/deep/.el-input.is-disabled .el-input__inner{
    border: none;
    background-color: #dcedff;
    color: #606266;
}
.dialogtnBox{
  display: flex;
  justify-content: space-between;
  /deep/.el-form-item--mini.el-form-item{
        margin-bottom: 15px!important;
  }

}
.zhong{
  /deep/.el-input__inner{
        width: 66px;
  }
  /deep/.el-input{
    width: auto;
  }
}
</style>
